import React from 'react';
import { createUseStyles } from 'react-jss';
import CalendarHeader from './CalendarHeader';
import CalendarBody from './CalendarBody';

const useStyles = createUseStyles({
  calendarContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 700,
    backgroundColor: '#fff',
  },
});

type Props = {
  date: string | Date;
  onDateChange: (date: Date) => void;
  onClickLeft?: () => void;
  onClickRight?: () => void;
  showActiveDate?: boolean; // should show active date bubble
  availableDates?: Date[];
  size?: 'small' | 'large';
  allowPastSelection?: boolean;
};

const Calendar = (props: Props) => {
  const {
    date,
    onDateChange,
    onClickLeft,
    onClickRight,
    showActiveDate = true,
    availableDates,
    size = 'small',
    allowPastSelection = false,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.calendarContainer}>
      <CalendarHeader
        date={date}
        onClickLeft={onClickLeft}
        onClickRight={onClickRight}
        size={size}
        allowPastSelection={allowPastSelection}
      />
      <CalendarBody
        date={date}
        onDateChange={onDateChange}
        showActiveDate={showActiveDate}
        availableDates={availableDates}
        size={size}
        allowPastSelection={allowPastSelection}
      />
    </div>
  );
};

export default Calendar;
